"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdeaCardTitle = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _urlGenerator = _interopRequireDefault(require("../../utils/urlGenerator"));

/**
 * IdeaCard title component - renders linked title.
 */
var IdeaCardTitle = function IdeaCardTitle(_ref) {
  var title = _ref.title,
      publicId = _ref.publicId;
  return (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)((0, _urlGenerator.default)('ideas', title, publicId))
  }, title);
};

exports.IdeaCardTitle = IdeaCardTitle;